import React, { useState, useEffect } from 'react';
import Part from "./Part";

export default function InteriorApp(props) {
  const [damages, setDamages] = useState(props.damages ? props.damages : {});
  useEffect(() => {
    document.getElementsByName(props.damagesInputName)[0].value = JSON.stringify(damages);
  }, [damages]);
  return (<div>
    <div className="grid-x grid-margin-x">
      {window.INTERIOR_PARTS.map(part => (
        <Part key={part.value}
              damages={damages[part.value] ? damages[part.value] : []}
              label={part.label}
              updateDamages={partDamages => {
                const newDamages = Object.assign({}, damages);
                if (newDamages[part.value] === undefined) {
                  newDamages[part.value] = [];
                }
                newDamages[part.value] = partDamages;
                setDamages(newDamages);
              }} />
      ))}
    </div>
  </div>);
}
